import { render } from "./MainSliderComponent.vue?vue&type=template&id=52837168"
import script from "./MainSliderComponent.vue?vue&type=script&lang=js"
export * from "./MainSliderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__